import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import { fetchWrapper } from '../../../helpers';

function Create({ meClose, loadList }) {

  const initialValues = {
    name: '',
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Template Name is required').matches(/^[a-zA-Z\s]+$/, 'Only letters are allowed, no numbers'),
  });

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/category/create`;
      await fetchWrapper.post(url, values);
      loadList();
      meClose();
      toast(`Record has been saved`, { type: 'info' });
    } catch (error) {
      toast.error('Error saving record');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        values,
        errors,
        touched,
        setFieldValue,
        handleChange,
        handleBlur,
      }) => (
        <form onSubmit={handleSubmit}>
          <FormControl isInvalid={errors.name && touched.name} style={{marginTop:"10px"}}>
            <FormLabel>Category Name <span style={{color:"red"}}>*</span></FormLabel>
            <Input
              name="name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder='Please Enter Category Name'
            />
            <FormErrorMessage>{errors.name}</FormErrorMessage>
          </FormControl>

          <Button
            type="submit"
            py="10px"
            px="25px"
            color="#fff"
            bg="#2563eb"
            fontSize="14px"
            fontWeight="500"
            fontFamily="'Open Sans', sans-serif"
            mt={5}
            mb={5}
          >
            Add New Category
          </Button>
        </form>
      )}
    </Formik>
  );
}

export default Create;